import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import "./Hisobkitob.css";
import api from "../api";

/* ================= Helpers ================= */
// $ maydoniga so'm kiritib yuborilmasligi uchun ogohlantirish chegarasi
const USD_WARN_LIMIT = 1000;

const normDecStr = (v) => {
  if (v == null) return "";
  let s = String(v).trim().replace(",", ".");
  s = s.replace(/[^\d.-]/g, "");
  if (s.includes("-")) s = (s.startsWith("-") ? "-" : "") + s.replace(/-/g, "");
  const i = s.indexOf(".");
  if (i !== -1) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, "");
  if (["", "-", ".", "-."].includes(s)) return "";

  return s;
};
const toNum = (v) => {
  const n = Number(normDecStr(v));
  return Number.isFinite(n) ? n : 0;
};
const toFixed3Str = (v) => {
  const n = Math.round(toNum(v) * 1000);
  const neg = n < 0;
  const abs = Math.abs(n);
  const ip = String(Math.floor(abs / 1000));
  const fp = String(abs % 1000).padStart(3, "0");
  return (neg ? "-" : "") + ip + "." + fp;
};
const moneyUSD = (v, { min = 2, max = 2 } = {}) =>
  toNum(v).toLocaleString("uz-UZ", { minimumFractionDigits: min, maximumFractionDigits: max }) + " so'm";
const moneyDollar = (v, { min = 2, max = 2 } = {}) =>
  toNum(v).toLocaleString("uz-UZ", { minimumFractionDigits: min, maximumFractionDigits: max }) + " $";
// Savdo/summani o'z valyutasida ko'rsatish
const moneyCur = (v, currency, opts) =>
  (currency === "usd" ? moneyDollar(v, opts) : moneyUSD(v, opts));
const fmtQty = (v) =>
  toNum(v).toLocaleString("uz-UZ", { minimumFractionDigits: 0, maximumFractionDigits: 3 });

const toLocalYMD = (d) => {
  const date = d instanceof Date ? d : new Date(d);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};
const todayStr = () => toLocalYMD(new Date());
const normalizeDate = (v) => {
  if (!v) return "";
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (!Number.isNaN(d.getTime())) return toLocalYMD(d);
  const m = s.match(/^(\d{2})[./-](\d{2})[./-](\d{4})$/);
  return m ? `${m[3]}-${m[1]}-${m[2]}` : "";
};

const toIntScaled = (v, scale) => {
  const s = normDecStr(v);
  const neg = s.startsWith("-");
  const body = neg ? s.slice(1) : s;
  const [ipRaw, fpRaw = ""] = body.split(".");
  const ip = ipRaw || "0";
  const fp = (fpRaw + "0".repeat(scale)).slice(0, scale);
  const n = Number(ip + fp);
  return neg ? -n : n;
};
const mulDec = (a, b, scaleA = 4, scaleB = 3) => {
  const ai = toIntScaled(a, scaleA);
  const bi = toIntScaled(b, scaleB);
  const denom = 10 ** (scaleA + scaleB);
  return (ai * bi) / denom;
};

/* ================= Status ================= */
const UI_STATES = { OVERDUE: "overdue_debtor", NOT_DUE: "debtor_not_due", NEUTRAL: "neutral", CREDITOR: "creditor" };
const normalizeBool = (v) => v === true || v === 1 || v === "1" || (typeof v === "string" && v.toLowerCase() === "true");
const SERVER2UI_STATUS = (s) => {
  switch ((s || "").toLowerCase()) {
    case "overdue_debtor": return UI_STATES.OVERDUE;
    case "debtor_not_due": return UI_STATES.NOT_DUE;
    case "neutral":        return UI_STATES.NEUTRAL;
    case "creditor":       return UI_STATES.CREDITOR;
    default:               return null;
  }
};
const computeUiStatus = ({ signedDebt, hasOverdue, dueDate }) => {
  const bal = toNum(signedDebt || 0);
  const due = normalizeDate(dueDate);
  if (bal < 0) {
    if (normalizeBool(hasOverdue)) return UI_STATES.OVERDUE;
    if (due && due <= todayStr()) return UI_STATES.OVERDUE;
    return UI_STATES.NOT_DUE;
  }
  if (bal > 0) return UI_STATES.CREDITOR;
  return UI_STATES.NEUTRAL;
};
const stateColor = (ui) =>
  ui === UI_STATES.OVERDUE ? "red" :
  ui === UI_STATES.NOT_DUE ? "yellow" :
  ui === UI_STATES.CREDITOR ? "green" : "gray";
const stateLabel = (ui) =>
  ui === UI_STATES.OVERDUE || ui === UI_STATES.NOT_DUE ? "Qarzdor" :
  ui === UI_STATES.CREDITOR ? "Haqdor" : "Neytral";

const cx = (...a) => a.filter(Boolean).join(" ");
const asArr = (res) => Array.isArray(res?.data) ? res.data : res?.data?.results || [];
const hasNext = (res) => Boolean(res?.data?.next);
const sellerSourceFromFilter = (value) => {
  if (value === "bozor") return "bozor";
  if (value === "sotuv") return "dastur";
  return "";
};
const sourceLabel = (value) => (value === "bozor" ? "Bozor" : "Sotuv");

/* ================= UI satrlar ================= */
const SellerRow = React.memo(function SellerRow({ item, checked, onToggle }) {
  return (
    <label className="seller-row" style={{ contain: "content" }}>
      <input type="radio" checked={checked} onChange={() => onToggle(item.id)} />
      <div className="sr-body">
        <div className="m-left">
          <div className="m-buyer">{item.name}</div>
          <div className="m-brand">{item.brand}</div>
          <div className="m-meta">
            {item.phone && <div className="m-phone">{item.phone}</div>}
            <div className="m-source">{item.sourceLabel}</div>
          </div>
        </div>
        <div className={cx("m-badge", item.color)}>{item.label}</div>
        <div className={cx("m-amount", item.color)}>
          {/* Har bir balans o'z valyutasida; ikkalasi ham bo'lsa ikkalasi chiqadi */}
          {(item.amountAbs > 0 || item.amountAbsUsd === 0) && <div>{moneyUSD(item.amountAbs)}</div>}
          {item.amountAbsUsd > 0 && <div>{moneyDollar(item.amountAbsUsd)}</div>}
        </div>
      </div>
    </label>
  );
});

const SaleRow = React.memo(function SaleRow({ s }) {
  const rowTone = s.isCredit ? (s.isOverdue ? "red" : "yellow") : "plain";
  const badge = s.payType === "naxt" ? "green" : "orange";
  const lineTotal = mulDec(s.unitUsd, s.qty, 4, 3);
  return (
    <div className={cx("sale-row", rowTone)} style={{ contain: "content" }}>
      <div className="sr-title">
        <span className="pill pill-soft">{s.product}</span>
        <span className="muted">{s.sku}</span>
        <span className="muted">
          {s.date ? new Date(s.date).toLocaleDateString("uz-UZ") : "—"}
        </span>
        <span className="muted">
          Sotilgan narxi: {moneyCur(s.unitUsd, s.currency, { min: 2, max: 4 })}
        </span>
        <span className="muted">{fmtQty(s.qty)} dona</span>
        <span className="pill blue">{s.sourceLabel}</span>
        {s.sellerName && <span className="muted">Haridor: {s.sellerName}</span>}
        {s.soldBy && <span className="muted">Sotgan: {s.soldBy}</span>}
        {s.note && <span className="muted">Izoh: {s.note}</span>}
        <span className={cx("pill", badge)}>
          {s.payType === "naxt" ? "Naqtga" : "Nasiya"}
        </span>
      </div>
      <div className="sr-right">{moneyCur(lineTotal, s.currency)}</div>
    </div>
  );
});

/* ================= Payment Modal ================= */
function PaymentModal({
  open,
  onClose,
  sellerName,
  sellerSignedDebtAmount = 0,
  sellerSignedDebtUsd = 0,
  dollarRate = 0,
  onSave,
}) {
  const [dollarCash, setDollarCash] = useState("");
  const [cashSom, setCashSom] = useState("");
  const [cardSom, setCardSom] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setDollarCash("");
      setCashSom("");
      setCardSom("");
      setNote("");
      setSaving(false);
    }
  }, [open]);

  if (!open) return null;

  // So'm to'lovi -> so'm balansiga, dollar to'lovi -> USD balansiga
  const somPayment = toNum(cashSom) + toNum(cardSom);
  const usdPayment = toNum(dollarCash);
  const newSignedAfter = toNum(sellerSignedDebtAmount) + somPayment;
  const newSignedUsdAfter = toNum(sellerSignedDebtUsd) + usdPayment;
  const canSave = somPayment > 0 || usdPayment > 0;
  // $ maydoniga so'm kiritib yuborilmasligi uchun ogohlantirish
  const usdLooksLikeSom = usdPayment >= USD_WARN_LIMIT;
  const usdAsSom = toNum(dollarRate) > 0 ? Math.round(usdPayment * toNum(dollarRate)) : 0;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e)=>e.stopPropagation()}>
        <div className="modal-head">
          <div className="modal-title">
            <b>Haridor:</b> {sellerName || "-"} | <b>Nasiya to'lovi</b>
          </div>
          <button className="btn" onClick={onClose}>X</button>
        </div>
        <div className="modal-body">
          <div className="muted" style={{ marginBottom: 8 }}>
            Joriy balans: <b>{moneyUSD(sellerSignedDebtAmount)}</b>
            {toNum(sellerSignedDebtUsd) !== 0 && <> | <b>{moneyDollar(sellerSignedDebtUsd)}</b></>}
          </div>
          <label className="form-row">
            <span>$:</span>
            <input
              className="input"
              inputMode="decimal"
              value={dollarCash}
              onChange={(e)=>setDollarCash(e.target.value.replace(/[^\d.,]/g,"").replace(",","."))}
            />
          </label>
          {usdLooksLikeSom && (
            <div style={{ color: "#c0392b", fontWeight: 600, margin: "4px 0 8px" }}>
              ⚠️ Diqqat: bu <b>dollar</b> maydoni. Siz {usdPayment.toLocaleString("uz-UZ")} $ kiritdingiz
              {usdAsSom > 0 ? ` (≈ ${usdAsSom.toLocaleString("uz-UZ")} so'm)` : ""}.
              So'm to'lovini quyidagi "So'm" maydoniga kiriting.
            </div>
          )}
          <label className="form-row">
            <span>So'm:</span>
            <input
              className="input"
              inputMode="numeric"
              value={cashSom}
              onChange={(e)=>setCashSom(e.target.value.replace(/[^\d]/g,""))}
            />
          </label>
          <label className="form-row">
            <span>So'm (Karta):</span>
            <input
              className="input"
              inputMode="numeric"
              value={cardSom}
              onChange={(e)=>setCardSom(e.target.value.replace(/[^\d]/g,""))}
            />
          </label>
          <label className="form-row">
            <span>Izoh:</span>
            <textarea
              className="input"
              rows={3}
              value={note}
              onChange={(e)=>setNote(e.target.value)}
            />
          </label>

          <div className="muted">
            {somPayment > 0 && (
              <div>
                So'm to'lovi: <b>{moneyUSD(somPayment)}</b> — yangi so'm balansi: <b>{moneyUSD(newSignedAfter)}</b>
              </div>
            )}
            {usdPayment > 0 && (
              <div>
                Dollar to'lovi: <b>{moneyDollar(usdPayment)}</b> — yangi USD balansi: <b>{moneyDollar(newSignedUsdAfter)}</b>
              </div>
            )}
            {somPayment === 0 && usdPayment === 0 && <div>To'lov summasini kiriting.</div>}
          </div>
        </div>
        <div className="modal-foot">
          <button
            className="btn btn-primary"
            disabled={!canSave || saving}
            onClick={async ()=>{
              if (saving) return;          // ikki marta bosishdan himoya
              if (usdLooksLikeSom) {
                const ok = window.confirm(
                  `Siz dollar maydoniga ${usdPayment.toLocaleString("uz-UZ")} $ kiritdingiz` +
                  (usdAsSom > 0 ? ` (≈ ${usdAsSom.toLocaleString("uz-UZ")} so'm).` : ".") +
                  `\n\nHaqiqatan ham shuncha DOLLAR to'landimi?\n` +
                  `Agar bu so'm bo'lsa — "Bekor qilish" ni bosing va "So'm" maydoniga kiriting.`
                );
                if (!ok) return;
              }
              setSaving(true);
              try {
                await onSave?.({
                  dollar_cash: toNum(dollarCash || 0),
                  cash_som: Math.round(toNum(cashSom || 0)),
                  card_som: Math.round(toNum(cardSom || 0)),
                  note: note.trim()
                });
                onClose();
              } finally {
                setSaving(false);
              }
            }}
          >
            {saving ? "Saqlanmoqda..." : "Saqlash"}
          </button>
        </div>
      </div>
    </div>
  );
}
/* ================= Main Page ================= */
export default function Hisobkitob() {
  /* qidiruv */
  const [qSeller, setQSeller] = useState("");
  const [qProduct, setQProduct] = useState("");
  const [debQSeller, setDebQSeller] = useState("");
  const [debQProduct, setDebQProduct] = useState("");
  useEffect(()=>{
    const t=setTimeout(()=>setDebQSeller(qSeller.trim()),300);
    return ()=>clearTimeout(t);
  },[qSeller]);
  useEffect(()=>{
    const t=setTimeout(()=>setDebQProduct(qProduct.trim()),300);
    return ()=>clearTimeout(t);
  },[qProduct]);

  /* ko‘rinish + tanlov */
  const [view, setView] = useState("sellers");
  const [selectedSellerIds, setSelectedSellerIds] = useState([]);
  const oneSelected = selectedSellerIds.length === 1 ? selectedSellerIds[0] : null;

  /* filtrlar */
  const [payFilter, setPayFilter] = useState("all"); // all | naxt | nasiya
  const [sourceFilter, setSourceFilter] = useState("all"); // all | sotuv | bozor
  // Hisob-kitob standart holatda BARCHA skladlarni ko'rsatadi (boshqa sklad
  // tanlagichga bog'liq emas) — shunda hamma account (masalan Avtofayz 2 dagi
  // Girvon) savdolari darrov ko'rinadi. Kerak bo'lsa quyidagi tanlagichdan
  // bitta skladga toraytiriladi.
  const [warehouse, setWarehouse] = useState("all");

  // Sana filtri – doim bugungi kun bilan
  const [dateFrom, setDateFrom] = useState(todayStr());
  const [dateTo, setDateTo] = useState(todayStr());

  // Kassir (account) bo‘yicha filtr
  const [userFilter, setUserFilter] = useState("all");
  const [userOptions, setUserOptions] = useState([]);

  /* modal */
  const [openModal, setOpenModal] = useState(false);

  /* data */
  const [sellers, setSellers] = useState([]);
  const [sales, setSales] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [dollarRate, setDollarRate] = useState(0);

  useEffect(()=>{
    let alive = true;
    api.get("kurs/")
      .then((k)=> { if (alive) setDollarRate(toNum(k?.data?.naqd) || 0); })
      .catch(()=>{});
    return ()=> { alive = false; };
  }, []);

  /* paging */
  const SELLERS_PAGE_SIZE = 50, SALES_PAGE_SIZE = 50;
  const [sellersPage, setSellersPage] = useState(1);
  const [sellersHasMore, setSellersHasMore] = useState(true);
  const sellerLoaderRef = useRef(null);
  const [loadingSellers, setLoadingSellers] = useState(false);

  const [salesPage, setSalesPage] = useState(1);
  const [salesHasMore, setSalesHasMore] = useState(true);
  const salesLoaderRef = useRef(null);
  const [loadingSales, setLoadingSales] = useState(false);

  const sellersAbortRef = useRef(null);
  const salesAbortRef = useRef(null);

  /* omborlar */
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("sklad/");
        const W = (Array.isArray(data) ? data : data?.results || [])
          .map(w => ({ id:String(w.id), name:w.nom || w.name || "", currency_mode: w.currency_mode || "som" }));
        setWarehouses([{ id:"all", name:"Barchasi", currency_mode:"som" }, ...W]);
      } catch (e) {
        console.log("WAREHOUSE ERR", e?.response?.status, e?.response?.data);
        alert("Sklad ro‘yxatini yuklashda xatolik.");
      }
    })();
  }, []);

  /* params builders */
  const buildSellerParams = useCallback((pageNum)=>{
    const p = new URLSearchParams();
    p.set("page",String(pageNum));
    p.set("page_size",String(SELLERS_PAGE_SIZE));
    const sellerSource = sellerSourceFromFilter(sourceFilter);
    if (sellerSource) p.set("source", sellerSource);
    return p;
  },[sourceFilter]);

  const buildSalesParams = useCallback((pageNum)=>{
    const p = new URLSearchParams();
    p.set("page",String(pageNum));
    p.set("page_size",String(SALES_PAGE_SIZE));
    if (selectedSellerIds.length) p.set("seller_ids", selectedSellerIds.join(","));
    if (warehouse !== "all") p.set("warehouse", warehouse);
    if (payFilter !== "all") p.set("pay_type", payFilter === "naxt" ? "naqd" : "nasiya");
    if (sourceFilter !== "all") p.set("source", sourceFilter);
    if (debQProduct) p.set("search", debQProduct);
    if (dateFrom) p.set("date_from", dateFrom);
    if (dateTo) p.set("date_to", dateTo);
    return p;
  },[selectedSellerIds, warehouse, payFilter, sourceFilter, debQProduct, dateFrom, dateTo]);

  /* sellers fetch */
  const fetchSellers = useCallback(async (pageNum, replace=false)=>{
    try { sellersAbortRef.current?.abort(); } catch {}
    const controller = new AbortController();
    sellersAbortRef.current = controller;
    setLoadingSellers(true);
    try {
      const res = await api.get(`sotuvchi/?${buildSellerParams(pageNum).toString()}`, { signal: controller.signal });
      const arr = asArr(res).map(s=>{
        const signed = s.qarhaq ?? 0;
        const signedUsd = s.qarhaq_usd ?? 0;
        const due = normalizeDate(s.next_due_date);
        const hasOver = normalizeBool(s.has_overdue);
        const srv = SERVER2UI_STATUS(s.current_status);
        // Ikkala balansdan biri manfiy bo'lsa ham qarzdor hisoblanadi
        const combined =
          (toNum(signed) < 0 || toNum(signedUsd) < 0) ? -1 :
          (toNum(signed) > 0 || toNum(signedUsd) > 0) ? 1 : 0;
        const ui = srv || computeUiStatus({ signedDebt: combined, hasOverdue: hasOver, dueDate: due });
        return {
          id: String(s.id),
          name: s.ismi,
          brand: s.Dokonnomi || "",
          phone: s.telraqam1 || s.telraqam2 || "",
          source: s.source || "dastur",
          sourceLabel: sourceLabel(s.source),
          uiState: ui,
          color: stateColor(ui),
          label: stateLabel(ui),
          amountAbs: Math.abs(toNum(signed)),
          amountAbsUsd: Math.abs(toNum(signedUsd)),
          signedDebt: toNum(signed),
          signedDebtUsd: toNum(signedUsd),
        };
      });
      setSellers(prev=> (replace ? arr : [...prev, ...arr]));
      setSellersHasMore(hasNext(res));
    } catch(e){
      if (e.name!=="CanceledError" && e.name!=="AbortError") {
        console.log("SELLERS ERR", e?.response?.status, e?.response?.data);
      }
      if (pageNum===1) setSellers([]);
      setSellersHasMore(false);
    } finally {
      setLoadingSellers(false);
    }
  },[buildSellerParams]);

  useEffect(()=>{
    setSellersPage(1);
    setSellers([]);
    setSellersHasMore(true);
    fetchSellers(1,true);
  },[buildSellerParams, fetchSellers]);

  useEffect(()=>{
    if (!sellerLoaderRef.current) return;
    const io = new IntersectionObserver(async([entry])=>{
      if (entry.isIntersecting && sellersHasMore && !loadingSellers && sellers.length>0){
        const next = sellersPage + 1;
        setSellersPage(next);
        await fetchSellers(next);
      }
    },{ rootMargin:"300px" });
    io.observe(sellerLoaderRef.current);
    return ()=>io.disconnect();
  },[sellerLoaderRef, sellersPage, sellersHasMore, loadingSellers, sellers.length, fetchSellers]);

  const toggleSeller = (id)=>{
    const sid = String(id);
    setSelectedSellerIds(prev => (prev.includes(sid) ? prev : [sid]));
  };

  useEffect(() => {
    setSelectedSellerIds((prev) => prev.filter((id) => sellers.some((seller) => seller.id === id)));
  }, [sellers]);

  const visibleSellers = useMemo(()=>{
    const q = debQSeller.toLowerCase();
    if (!q) return sellers;
    return sellers.filter((it) => {
      const name = (it.name || "").toLowerCase();
      const phone = (it.phone || "").toLowerCase();
      return name.includes(q) || phone.includes(q);
    });
  }, [sellers, debQSeller]);

  /* sales fetch */
  const fetchSales = useCallback(async (pageNum, replace=false)=>{
    try { salesAbortRef.current?.abort(); } catch {}
    const controller = new AbortController();
    salesAbortRef.current = controller;
    setLoadingSales(true);
    try {
      const res = await api.get(`sotilgan-maxsulot/?${buildSalesParams(pageNum).toString()}`, { signal: controller.signal });
      const today = todayStr();
      const mapped = asArr(res).map(r=>{
        const isCredit = r.tolov_turi === "nasiya";
        const dline = normalizeDate(r.nmuddat);
        const overdue = isCredit && dline && dline <= today;
        return {
          id: r.id,
          buyerId: String(r.sotuvchi),
          product: r.maxsulot_nom || r.maxsulot?.nom || "—",
          sku: r.maxsulot_seriyasi || r.maxsulot?.seriyasi || "—",
          date: r.created_at,
          unitUsd: String(r.narx ?? ""),
          currency: r.currency || "som",
          qty: String(r.sotilgansoni ?? ""),
          payType: r.tolov_turi === "naqd" ? "naxt" : "nasiya",
          warehouse: String(r.sklad),
          source: r.source || "sotuv",
          sourceLabel: sourceLabel(r.source),
          isCredit,
          isOverdue: overdue,
          sellerName: r.sotuvchi_ismi || r.sotuvchi_nomi || "",
          soldBy: r.created_by_username || r.created_by || "",
          note: r.izoh || r.note || r.comment || "",
        };
      });
      setSales(prev => (replace ? mapped : [...prev, ...mapped]));
      setSalesHasMore(hasNext(res));
    } catch(e){
      if (e.name!=="CanceledError" && e.name!=="AbortError") {
        console.log("SALES ERR", e?.response?.status, e?.response?.data);
      }
      if (pageNum===1) setSales([]);
      setSalesHasMore(false);
    } finally {
      setLoadingSales(false);
    }
  },[buildSalesParams]);

  useEffect(()=>{
    setSalesPage(1);
    setSales([]);
    setSalesHasMore(true);
    fetchSales(1,true);
  },[buildSalesParams, fetchSales, view]);

  useEffect(()=>{
    if (!salesLoaderRef.current) return;
    const io = new IntersectionObserver(async([entry])=>{
      if (entry.isIntersecting && salesHasMore && !loadingSales && sales.length>0){
        const next = salesPage + 1;
        setSalesPage(next);
        await fetchSales(next);
      }
    },{ rootMargin:"300px" });
    io.observe(salesLoaderRef.current);
    return ()=>io.disconnect();
  },[salesLoaderRef, salesPage, salesHasMore, loadingSales, sales.length, fetchSales]);

  const dateInRange = useCallback((iso, from, to)=>{
    const d = normalizeDate(iso);
    if (!d) return true;
    if (from && d < from) return false;
    if (to && d > to) return false;
    return true;
  },[]);

  // sotgan kassirlar ro'yxati (frontenddan)
  useEffect(() => {
    const seen = new Set();
    const opts = [];
    sales.forEach((s) => {
      if (s.soldBy) {
        const key = String(s.soldBy);
        if (!seen.has(key)) {
          seen.add(key);
          opts.push(key);
        }
      }
    });
    opts.sort((a, b) => a.localeCompare(b, "uz"));
    setUserOptions(opts);
  }, [sales]);

  const filteredSales = useMemo(()=>{
    return sales.filter(s=>{
      if (view==="sellers" && selectedSellerIds.length && !selectedSellerIds.includes(String(s.buyerId))) return false;
      if (!dateInRange(s.date, dateFrom, dateTo)) return false;
      if (payFilter!=="all" && s.payType !== payFilter) return false;
      if (sourceFilter!=="all" && s.source !== sourceFilter) return false;
      if (userFilter!=="all" && s.soldBy !== userFilter) return false;
      return true;
    });
  },[sales, view, selectedSellerIds, dateFrom, dateTo, dateInRange, payFilter, sourceFilter, userFilter]);

  // Hisobot valyutasi: do'kon tanlansa o'sha do'kon valyutasi, "Barchasi"da so'm.
  // Do'kon tanlanganda hamma savdo bir valyutada bo'ladi; "Barchasi"da esa
  // dollarlik qatorlar so'mga o'girilib jamlanadi (aralash).
  const reportCurrency = useMemo(() => {
    const w = warehouses.find(x => String(x.id) === String(warehouse));
    return (w?.currency_mode === "usd") ? "usd" : "som";
  }, [warehouses, warehouse]);
  const _rate = Math.max(1, toNum(dollarRate));
  const lineAmt = (s) => {
    const total = mulDec(s.unitUsd, s.qty, 4, 3);
    if (reportCurrency === "usd") {
      // Dollar hisobotda: dollar qatorlar o'z qiymatida, so'm qatorlar dollarga
      return s.currency === "usd" ? total : total / _rate;
    }
    // So'm hisobotda: som qatorlar o'z qiymatida, dollar qatorlar so'mga
    return s.currency === "usd" ? total * _rate : total;
  };
  const sumBy = (lst, pred=()=>true) =>
    lst.reduce((t,s)=> (pred(s) ? t + lineAmt(s) : t), 0);
  const totalCash = sumBy(filteredSales, s=> s.payType==="naxt");
  const totalCredit = sumBy(filteredSales, s=> s.payType==="nasiya");
  const totalOverdue = sumBy(filteredSales, s=> s.isCredit && s.isOverdue);
  const totalNotOverdue = sumBy(filteredSales, s=> s.isCredit && !s.isOverdue);
  const grandTotal = sumBy(filteredSales);

  const oneSellerObj = sellers.find(x=> x.id=== (oneSelected||""));
  const paymentBlocked = oneSellerObj?.source === "bozor";

  /* ====== To'lov (kassa + balans) ====== */
  const submitPayment = useCallback(async ({
    dollar_cash,
    cash_som,
    card_som,
    note,
  })=>{
    if (!oneSelected) { alert("Avval 1 ta haridor tanlang."); return; }
    if (oneSellerObj?.source === "bozor") {
      alert("Bozor mijoziga kirim qilish mumkin emas.");
      return;
    }
    const sid = Number(oneSelected);
    const buyerName = oneSellerObj?.name || "";
    const noteTrim = (note || "").trim();

    const cash = Math.round(toNum(cash_som));
    const card = Math.round(toNum(card_som));
    const somTotal = cash + card;
    const usdTotal = toNum(dollar_cash);

    // Bir amal = bir kalit. Takroriy yuborilsa server pulni ikki marta yozmaydi.
    const opId = `${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
    // Do'kon (filial): yuqoridagi tanlagichda aniq do'kon tanlangan bo'lsa shu,
    // aks holda server account'ga biriktirilgan do'konni o'zi aniqlaydi.
    const skladId = warehouse !== "all" ? Number(warehouse) : undefined;

    try {
      // So'mdagi to'lov -> so'm kassasi + so'm balansi
      if (somTotal > 0) {
        await api.post("kassa/income/", {
          buyer_name: buyerName,
          currency: "som",
          cash_som: cash,
          card_som: card,
          terminal_som: 0,
          note: noteTrim,
          client_op_id: `${opId}-som-kassa`,
          ...(skladId ? { sklad: skladId } : {}),
        });
        await api.post("payment/", {
          sotuvchi: sid,
          amount: toFixed3Str(somTotal),
          currency: "som",
          method: "hisobkitob",
          note: noteTrim,
          client_op_id: `${opId}-som-balans`,
          ...(skladId ? { sklad: skladId } : {}),
        });
      }

      // Dollardagi to'lov -> dollar kassasi + USD balansi
      if (usdTotal > 0) {
        await api.post("kassa/income/", {
          buyer_name: buyerName,
          currency: "usd",
          cash_som: usdTotal,
          card_som: 0,
          terminal_som: 0,
          note: noteTrim,
          client_op_id: `${opId}-usd-kassa`,
          ...(skladId ? { sklad: skladId } : {}),
        });
        await api.post("payment/", {
          sotuvchi: sid,
          amount: toFixed3Str(usdTotal),
          currency: "usd",
          method: "hisobkitob",
          note: noteTrim,
          client_op_id: `${opId}-usd-balans`,
          ...(skladId ? { sklad: skladId } : {}),
        });
      }

      // ro'yxatlarni yangilash
      setSellersPage(1); setSellers([]); setSellersHasMore(true);
      await fetchSellers(1,true);
      setSalesPage(1); setSales([]); setSalesHasMore(true);
      await fetchSales(1,true);

      alert("✅ To‘lov qabul qilindi va kassaga yozildi.");
    } catch (e) {
      console.log("PAYMENT ERR", e?.response?.status, e?.response?.data || e.message);
      const server = e?.response?.data;
      const msg = typeof server === "object" ? JSON.stringify(server) : (server || e.message);
      alert(`Xatolik: ${msg}`);
    }
  },[oneSelected, oneSellerObj, warehouse, fetchSales, fetchSellers]);

  /* ================= Render ================= */
  return (
    <div className="hisobkitob-page">
      {/* TOP: qidiruvlar */}
      <div className="topbar fr-panel">
        <input
          className="input"
          placeholder="Haridor qidiring…"
          value={qSeller}
          onChange={(e)=>setQSeller(e.target.value)}
        />
        <input
          className="input"
          placeholder="Mahsulot qidiring…"
          value={qProduct}
          onChange={(e)=>setQProduct(e.target.value)}
        />
      </div>

      {/* FILTER BAR */}
      <div className="filterbar fr-panel">
        <div className="left-tabs">
          <button
            className={cx("tab", view==="sellers" && "active")}
            onClick={()=>setView("sellers")}
          >
            Haridorlar
          </button>
          <button
            className={cx("tab", view==="all" && "active")}
            onClick={()=>setView("all")}
          >
            Barchasi
          </button>
        </div>

        <div className="right-controls">
          <div className="seg">
            <button
              className={cx("seg-btn", payFilter==="all" && "on")}
              onClick={()=>setPayFilter("all")}
            >
              Naqt/Nasiya
            </button>
            <button
              className={cx("seg-btn", payFilter==="naxt" && "on")}
              onClick={()=>setPayFilter("naxt")}
            >
              Naqt
            </button>
            <button
              className={cx("seg-btn", payFilter==="nasiya" && "on")}
              onClick={()=>setPayFilter("nasiya")}
            >
              Nasiya
            </button>
          </div>

          <select
            value={sourceFilter}
            onChange={(e)=>setSourceFilter(e.target.value)}
          >
            <option value="all">Manba: barchasi</option>
            <option value="sotuv">Sotuv sahifasi</option>
            <option value="bozor">Bozor</option>
          </select>

          <div className="date-range">
            <input
              className="input"
              type="date"
              value={dateFrom}
              onChange={(e)=>setDateFrom(e.target.value)}
            />
            <span className="sep">—</span>
            <input
              className="input"
              type="date"
              value={dateTo}
              onChange={(e)=>setDateTo(e.target.value)}
            />
            <button
              className="btn btn-ghost"
              onClick={()=>{
                const t = todayStr();
                setDateFrom(t);
                setDateTo(t);
              }}
            >
              Tozalash
            </button>
          </div>

          {/* Kassir bo‘yicha filtr */}
          <select
            value={userFilter}
            onChange={(e)=>setUserFilter(e.target.value)}
          >
            <option value="all">Barcha kassirlar</option>
            {userOptions.map(u => (
              <option key={u} value={u}>{u}</option>
            ))}
          </select>

          <select
            value={warehouse}
            onChange={(e)=>setWarehouse(e.target.value)}
          >
            {warehouses.map(w=> (
              <option key={w.id} value={w.id}>{w.name}</option>
            ))}
          </select>

          <button
            className="btn"
            disabled={paymentBlocked}
            onClick={()=>{
              if (selectedSellerIds.length !== 1) {
                alert("To‘lov uchun 1 ta haridor tanlang.");
                return;
              }
              setOpenModal(true);
            }}
          >
            {paymentBlocked ? "Bozor uchun yopiq" : "Kirim qilish"}
          </button>
        </div>
      </div>

      {/* GRID */}
      <div className="grid">
        {/* LEFT: sellers */}
        <div className="left fr-card">
          <div className="left-list">
            {visibleSellers.length ? (
              <>
                {visibleSellers.map(it=>(
                  <SellerRow
                    key={it.id}
                    item={it}
                    checked={selectedSellerIds.includes(String(it.id))}
                    onToggle={toggleSeller}
                  />
                ))}
                {loadingSellers && <div className="empty small">Yuklanmoqda…</div>}
                <div ref={sellerLoaderRef} style={{height:1}}/>
              </>
            ) : loadingSellers ? (
              <div className="empty">Yuklanmoqda…</div>
            ) : (
              <div className="empty">Hech narsa topilmadi</div>
            )}
          </div>
        </div>

        {/* RIGHT: sales */}
        <div className="right fr-card">
          {filteredSales.map(s => <SaleRow key={s.id} s={s} />)}
          {!filteredSales.length && !loadingSales && (
            <div className="empty">Maʼlumot topilmadi</div>
          )}
          {loadingSales && <div className="empty small">Yuklanmoqda…</div>}
          <div ref={salesLoaderRef} style={{height:1}}/>
        </div>
      </div>

      {/* BOTTOM SUM */}
      <div className="bottom-sum fr-panel">
        <div className="chip chip-yellow">
          Muddati o‘tmagan nasiyalar: <b>{moneyCur(totalNotOverdue, reportCurrency)}</b>
        </div>
        <div className="chip chip-yellow">
          Umumiy nasiyalar: <b>{moneyCur(totalCredit, reportCurrency)}</b>
        </div>
        <div className="chip chip-red">
          Muddati o‘tgan nasiyalar: <b>{moneyCur(totalOverdue, reportCurrency)}</b>
        </div>
        <div className="chip chip-green">
          Naqt savdo: <b>{moneyCur(totalCash, reportCurrency)}</b>
        </div>
        <div className="chip chip-green strong">
          Jami savdo: <b>{moneyCur(grandTotal, reportCurrency)}</b>
        </div>
      </div>

      {/* MODAL */}
      <PaymentModal
        open={openModal}
        onClose={()=>setOpenModal(false)}
        sellerName={oneSellerObj?.name}
        sellerSignedDebtAmount={oneSellerObj?.signedDebt || 0}
        sellerSignedDebtUsd={oneSellerObj?.signedDebtUsd || 0}
        dollarRate={dollarRate}
        onSave={submitPayment}
      />
    </div>
  );
}

